var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgSendIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 40,
    height: 35,
    viewBox: "0 0 40 35",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.0308 16.6038C12.2473 16.9261 12.61 17.1194 12.9982 17.1194L34.1206 17.1194C35.383 17.1194 35.7445 15.3927 34.5883 14.8863L4.6587 1.77675C3.59044 1.30884 2.57325 2.52625 3.22361 3.49431L12.0308 16.6038Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M12.0308 18.3766C12.2473 18.0544 12.61 17.8611 12.9982 17.8611L34.1206 17.8611C35.383 17.8611 35.7445 19.5877 34.5883 20.0942L4.6587 33.2037C3.59044 33.6716 2.57325 32.4542 3.22361 31.4862L12.0308 18.3766Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSendIcon);
export default __webpack_public_path__ + "static/media/SendIcon.6c716fe6cbe9599cc00fa2488ee78b8d.svg";
export { ForwardRef as ReactComponent };